import React from 'react'
import { Button } from '@material-ui/core'
import { useRouter } from 'next/router'

import { components } from '@plandi/common/src/generated'
import { useCreateSelectModalStyles } from './create-select-modal.styles'
import { URLS } from '../urls'
import { SERVICES_URL, useLocale, useTranslation } from '@plandi/common'

type Props = {
  type: string
  closeModal: () => void
  profileCompany?: components['schemas']['ProfileCompanyMeResource']
  profileFreelancer?: components['schemas']['ProfileSpecialistMeResource']
  isCompanyLoading?: boolean
  isFactoryLoading?: boolean
  isFreelancerLoading?: boolean
}

export const CreateSelectModal: React.FC<Props> = ({
  type,
  closeModal,
  profileCompany,
  profileFreelancer,
  isCompanyLoading,
  isFactoryLoading,
  isFreelancerLoading
}) => {
  const classes = useCreateSelectModalStyles()
  const router = useRouter()
  const { data: translate } = useTranslation()
  const locale = useLocale()
  const url = SERVICES_URL

  return (
    <div className={classes.root}>
      <div className={classes.modalContent}>
        <div className={classes.title}>
          {type === 'product'
            ? translate?.market?.['create-product-create-profile'] ??
              'Чтобы создать товар, необходимо создать анкету завода'
            : `${translate?.['choose-type-project']
                ?.replace('project', type === 'project' ? 'project' : 'model')
                ?.replace('проект', type === 'project' ? 'проект' : 'модель')}`}
        </div>
        {type === 'product' ? (
          <div className={classes.buttons}>
            <Button
              className={classes.firstBtn}
              variant="contained"
              color="primary"
              disabled={isFactoryLoading}
              onClick={() =>
                (window.location.href =
                  locale === 'ru'
                    ? `${url.job}/ru${'/profile-factory/create'}`
                    : url.job + '/profile-factory/create')
              }
            >
              {translate?.market?.['сreate-plant-profile'] ??
                'Создать анкету завода'}
            </Button>
          </div>
        ) : (
          <div className={classes.buttons}>
            {profileCompany ? (
              <Button
                className={classes.firstBtn}
                variant="contained"
                color="primary"
                onClick={() => {
                  router.push(
                    {
                      pathname:
                        type === 'project'
                          ? URLS.projects.create
                          : URLS.models.create,
                      query: { type: 'company' }
                    },
                    undefined,
                    {
                      shallow: true
                    }
                  )
                  closeModal()
                }}
              >
                {translate?.company}
              </Button>
            ) : (
              <Button
                className={classes.firstBtn}
                variant="contained"
                color="primary"
                disabled={isCompanyLoading}
                onClick={() =>
                  (window.location.href =
                    locale === 'ru'
                      ? `${url.job}/ru${'/profile-company/create'}`
                      : url.job + '/profile-company/create')
                }
              >
                {translate?.['job-site']?.['create-company']}
              </Button>
            )}
            {profileFreelancer ? (
              <Button
                className={classes.firstBtn}
                variant="contained"
                color="secondary"
                onClick={() => {
                  router.push(
                    {
                      pathname:
                        type === 'project'
                          ? URLS.projects.create
                          : URLS.models.create,
                      query: { type: 'freelancer' }
                    },
                    undefined,
                    {
                      shallow: true
                    }
                  )
                  closeModal()
                }}
              >
                {translate?.freelancer}
              </Button>
            ) : (
              <Button
                className={classes.firstBtn}
                variant="contained"
                color="secondary"
                disabled={isFreelancerLoading}
                onClick={() =>
                  (window.location.href =
                    locale === 'ru'
                      ? `${
                          url.job
                        }/ru${'/profile-specialist/freelancer-create'}`
                      : url.job + '/profile-specialist/freelancer-create')
                }
              >
                {translate?.['job-site']?.['create-specialist']}
              </Button>
            )}
            <Button
              className={classes.secondBtn}
              variant="outlined"
              color="primary"
              disabled={isCompanyLoading || isFreelancerLoading}
              onClick={() => {
                router.push(
                  {
                    pathname:
                      type === 'project'
                        ? URLS.projects.create
                        : URLS.models.create,
                    query: { type: 'user' }
                  },
                  undefined,
                  {
                    shallow: true
                  }
                )
                closeModal()
              }}
            >
              {translate?.['blog-site']?.['private-person']}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
